import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'

import './styles.css';

import ipad from '../../images/remoteretro/ipad.png';

class RemoteRetro extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');
    return (

      <div className="grid">
        <div className="grid-item-wide">
          <div className="element">
            <h1 className="title">RemoteRetro</h1>
          </div>
        </div>

        <div className="grid-item">
          <div className="element">
            <p>
              The team I work with at <Link to="http://www.theconversation.com" target="_blank">The Conversation</Link> has a remote team member, <Link to="https://twitter.com/keithpitty" target="_blank">Keith Pitty</Link>.
            </p>

            <p>
              We use a whiteboard, and that makes it hard for Keith to fully take part. He's joining in the conversation, but it's not the same thing. We thought that we needed a tool to have online retro boards.
            </p>
          </div>
        </div>

        <div className="grid-item">
          <div className="element">
            <p>
              Hence, <Link to="http://www.remoteretro.io" target="_blank">RemoteRetro</Link>. An online retro board, that everyone can log into. Or, throw it up on a projector or a screen, and only the remote team members can join in. Or, no remote team members, and use it to keep a record of the sprint's retro items. Up to you.
            </p>
          </div>
        </div>

        <div className="grid-item-padded grid-item grid-item-wide">
          <img src={ ipad } alt="Ipad" />
        </div>

        <div className="grid-item five-grid-item-prepend-three four-grid-item-prepend-two three-grid-item-prepend-one">
          <div className="element">
            <p>
              It allows users to add retro discussion points to four 'quadrants':
            </p>
            <ul>
              <li>
                Good things that happened
              </li>
              <li>
                Bad things that happened
              </li>
              <li>
                Tasks items from the retro
              </li>
              <li>
                Questions raised
              </li>
            </ul>
            <p></p>


          </div>
        </div>

        <div className="grid-item">
          <div className="element">
            <p>
              Inviting users to the retro is the simplest as well; copy/paste the URL.
            </p>
            <p>
              All users can update the retro in real time.
            </p>
            <p>
              To see this in action, please visit <Link to="http://www.remoteretro.io" target="_blank">RemoteRetro</Link>.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default RemoteRetro;




// WEBPACK FOOTER //
// ./src/pages/RemoteRetro/index.js